import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import { Dropdown, Row, Col } from 'react-bootstrap-5';

import { searchDocuments } from 'components/documents/api';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/bs5/unstyled_dropdown_toggle';
import Ottercon from 'components/ottercon';
import SidebarSearch from 'components/search_sidebar/sidebar_search';

export default class SearchBar extends React.Component {
  static propTypes = {
    marketing: PropTypes.bool.isRequired,
    projectId: PropTypes.number.isRequired,
    onFolderSelect: PropTypes.func.isRequired
  }

  state = {
    searchText: '',
    searchResults: []
  }

  searchDocuments = () => {
    searchDocuments(this.props.projectId, !!this.props.marketing, this.state.searchText).then((data) => {
      this.setState({ searchResults: data.results });
    });
  }

  debouncedSearchDocuments = debounce(this.searchDocuments, 250);

  handleSearchTextChange = (e) => {
    const { value } = e.target;
    this.setState((state) => {
      let { searchResults, searchText } = { ...state };
      searchText = value;
      if (value.length === 0) searchResults = [];
      return { searchResults, searchText };
    });
    if (value.length > 2) this.debouncedSearchDocuments();
  }

  handleSelect = (item) => {
    const folderId = item.folder ? item.id : item.folderId;
    const highlightedDocumentId = item.folder ? null : item.id;
    this.props.onFolderSelect(folderId, highlightedDocumentId);
  }

  renderSearchResult = (document) => {
    return (
      <Dropdown.Item
        className="border-bottom"
        key={document.id}
        name="search-result-row"
        onClick={() => this.handleSelect(document)}
      >
        <Row className="align-items-center gx-2 w-100 text-nowrap">
          <Col xs="auto">
            <Ottercon ottercon={document.icon}/>
          </Col>
          <Col className="text-truncate">
            <div className="title title-medium text-truncate">
              {document.name}
            </div>
            <div className="small">
              in '{document.folderName}'
            </div>
          </Col>
        </Row>
      </Dropdown.Item>
    );
  }

  render() {
    const { searchResults, searchText } = this.state;
    return (
      <Dropdown id="docs-search-results">
        <Dropdown.Toggle as={UnstyledDropdownToggle}>
          <SidebarSearch
            name="search_text"
            placeholder="Search Files..."
            value={searchText}
            onChange={this.handleSearchTextChange}
          />
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-0 py-0 search-results border-none">
          {searchResults.map(this.renderSearchResult)}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
